import { globalConstants } from "../constants";
import {
  putRequest,
  getRequest,
  postRequest,
  deleteRequest,
  getRequestWithParams,
  postRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getStudentsByInstructorId(instructorId, gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/instructor/courses/${instructorId}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getStatsByInstructorId(instructorId) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/instructor/courses/stats/${instructorId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addStudent(data) {
  return postRequest(
    `/${globalConstants.VERSION}/course`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getStudentByEmail(email) {
  return postRequest(
    `/${globalConstants.VERSION}/user/student`,
    email,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getStudentById(id) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/Course/course/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getNonVerifiedStudentById(id) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/Course/nonVerifiedUserCourse/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getStudentsByCenterId(centerId, gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/Center/courses/${centerId}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllCourses(gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/admin/course/all`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCoursesBySystemId(systemId, gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/course/courses/${systemId}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getQuestions() {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/Feedback/questions`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addFeedback(data) {
  return postRequest(
    `/${globalConstants.VERSION}/feedback/feedbackResponse/course`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getFeedbackByCourseId(id) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/Feedback/course/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function publishOrDisableFeedback(data) {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Course/approval/course`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const CourseService = {
  getStudentsByInstructorId,
  getStatsByInstructorId,
  addStudent,
  getStudentByEmail,
  getStudentById,
  getStudentsByCenterId,
  getAllCourses,
  getCoursesBySystemId,
  getQuestions,
  addFeedback,
  getFeedbackByCourseId,
  publishOrDisableFeedback,
  getNonVerifiedStudentById
};
